import { createContext } from 'react';
import {
	IApkForAssign,
	TApkType,
	IDataGetRestaurantsByIDsCustomersForApk,
	IDataGetApkByIDsRestaurantsForApk,
	IDataGetCustomersForAssignApk,
} from 'types';

export type TIDSelectedTypeApk = null | TApkType;
export type TActiveItemToDisplay = 'customers' | 'restaurants' | 'apk';
export type TTypeOfModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSendChanges'
	| 'success'
	| 'error'
	| 'apkLimit'
	| 'apkOfSameType'
	| 'restaurantAlreadyHasSelectedApkType';
export interface IIDsSelectedItems {
	[key: string]: boolean; // key - is the ID and boolean means open or closed tab status.
}
export interface IApkWithAdditionalProperty extends IDataGetApkByIDsRestaurantsForApk {
	isChanged: boolean;
}
export type TCountOfItems = '12' | '24' | '48';

export interface IApkAssignmentState {
	apkForAssign: IApkForAssign;
	searchString: string;
	searchStringForAllCustomers: string;
	searchStringForRestaurants: string;
	searchStringForApk: string;
	IDSelectedTypeApk: TIDSelectedTypeApk;
	isUnassignedApk: boolean;
	IDsSelectedApk: string[];
	activeItemToDisplay: TActiveItemToDisplay;
	isShowBreadcrumbs: boolean;
	allCustomers: IDataGetCustomersForAssignApk[];
	IDsSelectedCustomers: IIDsSelectedItems;
	restaurants: IDataGetRestaurantsByIDsCustomersForApk[];
	IDsSelectedRestaurants: IIDsSelectedItems;
	apk: IApkWithAdditionalProperty[];
	typeOfModalWindow: TTypeOfModalWindow;
	currentPage: number;
	countOfItems: TCountOfItems;
}

export const apkAssignmentInitialState: IApkAssignmentState = {
	apkForAssign: { count: 0, items: [] },
	searchString: '',
	searchStringForAllCustomers: '',
	searchStringForRestaurants: '',
	searchStringForApk: '',
	IDSelectedTypeApk: null,
	isUnassignedApk: false,
	IDsSelectedApk: [],
	activeItemToDisplay: 'customers',
	isShowBreadcrumbs: false,
	allCustomers: [],
	IDsSelectedCustomers: {},
	restaurants: [],
	IDsSelectedRestaurants: {},
	apk: [],
	typeOfModalWindow: null,
	currentPage: 1,
	countOfItems: '12',
};

export interface IApkAssignmentContext extends IApkAssignmentState {
	changeSearchString(value: string): void;
	changeSearchStringForAllCustomers(value: string): void;
	changeSearchStringForRestaurants(value: string): void;
	changeSearchStringForApk(value: string): void;
	changeTypeApk(value: TIDSelectedTypeApk): void;
	resetSelectedControls(): void;
	changeIsUnassignedApkStatus(value: boolean): void;
	setIDsSelectedApk(value: string[]): void;
	changeActiveItemToDisplay(value: TActiveItemToDisplay): void;
	setShowBreadcrumbs(value?: boolean): void;
	setIDsSelectedCustomers(value: IIDsSelectedItems, isUpdateRestaurantsList: boolean): Promise<void>;
	setIDsSelectedRestaurants(value: IIDsSelectedItems, isUpdateApkList: boolean): Promise<void>;
	addSelectedApkToRestaurant(): void;
	deleteApkFromRestaurant(restaurantID: string, firmwareID: string): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	changeCurrentPage(page: number): void;
	resetChanges(): void;
	sendChanges(): Promise<void>;
	updateModuleDataAfterSaving(): void;
}

export const ApkAssignmentContext = createContext<IApkAssignmentContext>({
	changeSearchString: () => undefined,
	changeSearchStringForAllCustomers: () => undefined,
	changeSearchStringForRestaurants: () => undefined,
	changeSearchStringForApk: () => undefined,
	changeTypeApk: () => undefined,
	resetSelectedControls: () => undefined,
	changeIsUnassignedApkStatus: () => undefined,
	setIDsSelectedApk: () => undefined,
	changeActiveItemToDisplay: () => undefined,
	setShowBreadcrumbs: () => undefined,
	setIDsSelectedCustomers: async () => undefined,
	setIDsSelectedRestaurants: async () => undefined,
	addSelectedApkToRestaurant: () => undefined,
	deleteApkFromRestaurant: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	changeCurrentPage: () => undefined,
	resetChanges: () => undefined,
	sendChanges: async () => undefined,
	updateModuleDataAfterSaving: () => undefined,
	...apkAssignmentInitialState,
});
